const z = {
    string: () => ({
        type: 'string',
        safeParse: (v, path = []) => {
            if (typeof v === 'string') return { success: true, data: v }
            return error('Expected string', path)
        },
    }),
    number: () => ({
        type: 'number',
        safeParse: (v, path = []) => {
            if (typeof v === 'number') return { success: true, data: v }
            return error('Expected number', path)
        },
    }),
    boolean: () => ({
        type: 'boolean',
        safeParse: (v, path = []) => {
            if (typeof v === 'boolean') return { success: true, data: v }
            return error('Expected boolean', path)
        },
    }),
    array: (item) => ({
        type: 'array',
        safeParse: (v, path = []) => {
            if (!Array.isArray(v)) return error('Expected array', path)
            const out = []
            const allErrors = []
            v.forEach((val, i) => {
                const r = item.safeParse(val, [...path, i])
                r.success ? out.push(r.data) : allErrors.push(...r.error.errors)
            })
            return allErrors.length ? { success: false, error: { errors: allErrors } } : { success: true, data: out }
        },
    }),
    object: (shape, refineFn = null) => ({
        type: 'object',
        safeParse: (v, path = []) => {
            if (!v || typeof v !== 'object') return error('Expected object', path)
            const out = {}
            const allErrors = []
            for (const [k, s] of Object.entries(shape)) {
                const r = s.safeParse(v[k], [...path, k])
                r.success ? (out[k] = r.data) : allErrors.push(...r.error.errors)
            }
            if (refineFn) {
                const refineResult = refineFn(out)
                if (refineResult !== true) {
                    const entries = Array.isArray(refineResult) ? refineResult : [refineResult]

                    for (const { message, path: relPaths = [] } of entries) {
                        for (const key of relPaths) {
                            allErrors.push({
                                message,
                                path: [...path, key],
                            })
                        }
                    }
                }

            }

            if (allErrors.length) {
                return { success: false, error: { errors: allErrors } }
            }

            return { success: true, data: out }
        },
    }),
    optional: (s) => ({
        type: 'optional',
        safeParse: (v, path = []) => (v === undefined ? { success: true, data: undefined } : s.safeParse(v, path)),
    }),
}

const error = (message, path) => ({
    success: false,
    error: { errors: [{ message, path }] },
})

export { z }
